import React from 'react';
import Lottie from 'lottie-react';
import loaderAnimation from '../loaders.json';

/**
 * Page-level brand loader. `size` is honoured because this used to render at a
 * fixed 200×200 everywhere — including inside the purchase button, where it
 * blew the button out of the layout. Inline/button spinners use <Spinner />.
 */
const Loader = ({ size = 140 }) => (
  <div
    style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
    }}
  >
    <Lottie animationData={loaderAnimation} loop style={{ width: size, height: size }} />
  </div>
);

export default Loader;
